// extracted by mini-css-extract-plugin
module.exports = {"link":"TextOnlyButton_link__3Uove","block":"TextOnlyButton_block__2RAaX"};